import { createAxiosClient } from '../axiosDefaults';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const {
    locale,
    country
  } = config;
  const MAPPING_URL = ExtraMappingUrlsByLocale[locale];
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    getMappingWithLicensePlate,
    searchCarDataMapping
  };

  function getMappingWithLicensePlate(licensePlate) {
    if (!MAPPING_URL) {
      return Promise.reject(new Error("Attempting to get license plate mapping with invalid locale " + locale));
    }

    return axiosInstance.post(MAPPING_URL, {
      licensePlate
    }).then(r => {
      return r.data;
    });
  }

  function searchCarDataMapping(licensePlate) {
    return axiosInstance.post("/license-plate/mapping", {
      licensePlate,
      country
    }).then(r => {
      return r.data;
    });
  }
}
const ExtraMappingUrlsByLocale = {
  'nl': '/license-plate/nl/mapping',
  'sv-SE': '/sweden-license-plate/extra-mapping'
};